module.exports = __webpack_public_path__ + "static/SectionOneBackground.904c4b95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pngs/SectionOneBackground.png
// module id = 499
// module chunks = 35783957827783